import watch from 'redux-watch';
import {
    addToWishlist,
    checkWishlists,
    saveFormValidation
} from '../actions/productActions';

import {
    buildErrorsFromResponse
} from '../../../core/js/utils/errorHandling';

import { error, warn, debug } from '../../../core/js/utils/logger';

import template from 'product-wishlist-list.j2';
import confirmationTemplate from 'wishlist/wishlist-moved.j2';

import { moveToWishListSaga } from '../sagas/productWishListSagas';

import { generate } from '../../../core/js/utils/componentUtils';
import { init as genericModalInit } from '../../../core/js/components/genericModalContentsComponent';
import { pushModalTransition } from '../../../core/js/actions/modalActions';
import { onStateChange as commonOnStateChange } from '../utils/productComponentUtils';
import { isQuickshop } from '../utils/quickshopUtils';
import { mDom } from '../../../core/js/utils/renderUtils';
import productUtils from '../utils/utils';
import { createGAEvent } from '@core/js/utils/analyticsUtils';
import { handleUtagEvent } from '@core/js/actions/initialActions';

export function onStateChange(store, watchValue, oldVal, newVal) {
    commonOnStateChange.bind(this)(store, watchValue, oldVal, newVal);

    const product = this.getTargetedProduct(store.getState());
    const wishLists = _.get(product, 'productAddToWishList.wishlists', []);

    // If the state is changing and there are wishlists in it
    // assume we are opening the list for the first time and toggle the
    // open class on the sibling link and show the UL
    if (wishLists.length > 0) {
        $(this.scopedSelector('.js-product-add-links__ul')).show();
        $(this.scopedSelector()).siblings('.dom-wishlist-add')
            .find('.js-create-wishlist-ui')
            .addClass('is-open');
    }
}

function formValidation(e, store, action, params, component) {
    const formEl = $(component.templateLocation).parents('.js-product-add-form');

    if (formEl.length > 0) {
        formEl.parsley().whenValidate()
            .then(() => {
                store.dispatch(action(params, e, component));
            });
    } else if (params) {
        store.dispatch(action(params, e, component));
    } else {
        store.dispatch(action(undefined, e, component));
    }
}

export function displayConfirmationModal(store, moveToListName, moveToListId, e) {
    const confirmInit = function(store, overrides = {}) {
        overrides.wishlistName = moveToListName;
        overrides.wishlistId = moveToListId;
        overrides.template = confirmationTemplate;
        return genericModalInit(store, overrides);
    };

    const payload = pushModalTransition(confirmInit, {}, e);

    $.event.trigger({
        type: payload.type,
        payload: payload
    });
}

/**
 * Attach component events to DOM
 * @param {object} store The store
 */
function attachEvents(store) {
    $(document).on(this.scopedEvent('click'), this.scopedSelector('.js-create-wishlist-ui'), (e) => {
        let state = store.getState();
        const product = productUtils.getTargetedProduct(store.getState, this);
        const hasWishlists = typeof product.productAddToWishList.wishlists;

        // If there are no Wishlists retrieved yet, go through the whole process
        // Otherwise, simply re-show the UI
        if (hasWishlists === 'undefined') {
            formValidation.bind(this)(e, store, checkWishlists, undefined, this);
        } else {
            $(`${this.templateLocation} .js-product-add-links__ul`).show();
        }
    });

    /**
     * When not in the ownerView from quickshop, the wishlist drop-down acts as
     *  an ADD to wishlist
     */
    $(document).on(this.scopedEvent('click'), this.scopedSelector('.js-add-to-wishlist'), (e) => {
        e.preventDefault();
        const target = $(e.target);
        const id = target.attr('data-wishlistid');
        const name = target.attr('data-wishlistname');
        const params = {
            id: id,
            name: name,
            fromDropdown: true
        };

        formValidation.bind(this)(e, store, addToWishlist, params, this);
    });

    /**
     * When in the ownerView of quickshop the wishlist drop down is a MOVE operation
     */
    $(document).on(this.scopedEvent('touchend click'), '.js-move-to-different-list', (e) => {
        e.preventDefault();

        const target = $(e.target);
        const moveToListId = target.attr('data-wishlistid');
        const moveToListName = target.attr('data-wishlistname');
        const params = {
            id: moveToListId
        };
        const product = this.getTargetedProduct(store.getState());

        const meta = {
            event: e,
            component: this,
            store: store
        };

        const gaEvent = createGAEvent(
            'PAGE_TYPE',
            'move item',
            `different list | ${_.get(product, 'product.displayName', '')}`
        );

        store.runSaga(moveToWishListSaga, params, meta).done.then(() => {
            store.dispatch(handleUtagEvent(gaEvent, 'link'));
            displayConfirmationModal(store, moveToListName, moveToListId, e);
        }).catch((err) => {
            error(`error moving to wishlist: ${err}`);
            if (err.entity) {
                const messages = buildErrorsFromResponse(err);

                if (err.entity.field_errors) {
                    store.dispatch(saveFormValidation({}, messages, {}, this));
                }
            } else {
                warn('Unable to move to wishlist.', err);
            }
        });
    });
}

export function init(store, overrides = {}) {
    const config = {
        templateLocation: '.dom-pdp .dom-main-product .dom-wishlist-list',
        onStateChange: onStateChange,
        attachEvents: attachEvents,
        watch: ['product.productAddToWishList.wishlists'],
        template: template,
        name: 'productWishListMultipleComponent',
        renderType: mDom,
        forFamilyProduct: false,
        listName: 'WISHLIST'
    };

    return generate(config, store, overrides);
}
